document.addEventListener("alpine:init", () => {
    Alpine.data("sparePartSearch", () => ({
        query: '',
        results: { products: [] },
        hasProducts: false,
        loading: false,
        showResults: false,
        showNoResults: false,
        userHasSearched: false,
        debounceTimer: null,
        abortController: null,

        search() {
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }

            const trimmedQuery = this.query.trim();

            if (trimmedQuery.length < 3) {
                if (this.userHasSearched) {
                    this.results = { products: [] };
                    this.hasProducts = false;
                    this.showResults = false;
                    this.showNoResults = false;
                }
                this.loading = false;
                return;
            }

            this.loading = true;

            this.debounceTimer = setTimeout(() => {
                this.performSearch(trimmedQuery);
            }, 300);
        },

        performSearch(trimmedQuery) {
            if (this.abortController) {
                this.abortController.abort();
            }

            this.abortController = new AbortController();
            this.userHasSearched = true;

            fetch(sparePartSearchAjax.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'spare_part_search',
                    query: trimmedQuery
                }),
                signal: this.abortController.signal
            })
                .then(res => res.json())
                .then(data => {
                    this.loading = false;

                    this.results = {
                        products: data.products.map(item => ({
                            id: item.id,
                            title: item.title,
                            permalink: item.permalink,
                            image: item.image ?? null,
                            brand: item.brand ?? null,
                            sku: item.sku ?? null,
                            related_products: item.related_products.map(rp => ({
                                id: rp.id,
                                title: rp.title,
                                permalink: rp.permalink,
                                image: rp.image ?? null,
                                sku: rp.sku ?? null,
                                price: rp.price ?? null,
                            }))
                        }))
                    };

                    this.hasProducts = this.results.products.length > 0;

                    if (this.hasProducts) {
                        this.showResults = true;
                        this.showNoResults = false;
                    } else {
                        this.showResults = false;
                        this.showNoResults = true;
                    }
                })
                .catch(err => {
                    // Ignorera avbrutna anrop
                    if (err.name === 'AbortError') {
                        return;
                    }
                    console.error('Fetch error:', err);
                    this.loading = false;
                    this.results = { products: [] };
                    this.hasProducts = false;
                    this.showResults = false;
                    this.showNoResults = false;
                });
        },

        clearSearch() {
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            if (this.abortController) {
                this.abortController.abort();
            }
            this.query = '';
            this.results = { products: [] };
            this.hasProducts = false;
            this.showResults = false;
            this.showNoResults = false;
            this.userHasSearched = false;
            this.loading = false;
        }
    }));
});
